function env(key: string, defaultValue?: string): string {
  const prefix: string = 'REACT_APP_'
  const envVal = process.env[`${prefix}${key}`] || defaultValue
  if (!envVal) {
    throw new Error(`Environment variable ${key} missing with no default value`)
  }
  return envVal
}

const config = {
  redirectBaseUrl: env('REDIRECT_BASE_URL'),
  clientId: env('CLIENT_ID'),
  oidcConfigUrl: env('OIDC_CONFIG_URL'),
  apiUrl: env('API_BASE_URL'),
  subPath: env('SUB_PATH'),
  paths: {
    oidcAuthCodePKCE: env("REACT_APP_OIDC_IMPLICIT_PATH", "/oidc/auth-code-pkce"),
    oidcImplicit: env("REACT_APP_OIDC_IMPLICIT_PATH", "/oidc/implicit"),
    oidcFirmMember: env("REACT_APP_OIDC_FIRM_MEMBER_PATH", "/oidc/firm-user"),
    oidcAuthCode: env("REACT_APP_OIDC_IMPLICIT_PATH", "/oidc/auth-code"),
  }
}

export default config
